import { createContext, useState, useEffect, useContext } from 'react';
import { createClient } from '@supabase/supabase-js';

// --- CONFIGURATION SUPABASE ---
// Remplace par tes vraies clés (trouvables dans Supabase > Settings > API)
const supabaseUrl = 'https://lgsddceccsvmrnfimxjy.supabase.co'; // Ton URL Project Supabase
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxnc2RkY2VjY3N2bXJuZmlteGp5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI1OTEzODUsImV4cCI6MjA3ODE2NzM4NX0.OZ1RJSPOjQEL1n4JYMjD-r0t34JQi_w5x4dcqRPSCfQ'; // ⚠️ ATTENTION : METS TA CLÉ "anon" ICI
// ------------------------------

export const supabase = createClient(supabaseUrl, supabaseKey);

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [session, setSession] = useState(null);

    useEffect(() => {
        // Vérifier la session active au démarrage
        supabase.auth.getSession().then(({ data: { session } }) => {
            setSession(session);
            setUser(session?.user ?? null);
            setLoading(false);
        });

        // Écouter les changements
        const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
            setSession(session);
            setUser(session?.user ?? null);
            setLoading(false);
        });

        return () => subscription.unsubscribe();
    }, []);

    const signInWithGoogle = async () => {
        const { error } = await supabase.auth.signInWithOAuth({
            provider: 'google',
            options: {
                redirectTo: 'https://app.arrow-studio.cloud'
            }
        });
        if (error) console.error("Erreur login:", error.message);
    };

    const signOut = async () => {
        await supabase.auth.signOut();
    };

    const getToken = async () => {
        const { data } = await supabase.auth.getSession();
        return data.session?.access_token || null;
    };

    return (
        <AuthContext.Provider value={{ user, session, signInWithGoogle, signOut, getToken, loading }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
}; 
